import React, { useCallback, useState } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CircularProgress from '@mui/material/CircularProgress'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { debounce } from '../../utilities/utilities'
import db from '../../../db/db'

function VisitAutoComplete(props) {
  const {
    label = '',
    value,
    setValue,
    disabled = false,
    direction = 'row',
    justifyContent = 'space-between',
    alignItems = 'center',
    sx = {},
  } = props

  const { t } = useTranslation()

  const [inputValue, setInputValue] = useState('')
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)

  const onSearch = inputValue => {
    if (inputValue.length === 0) return setOptions([])
    setLoading(true)

    const lower = inputValue.toLowerCase()
    db.comes_from
      .filter(c => (c.name ?? '').toLowerCase().startsWith(lower))
      .toArray()
      .then(results => {
        const unique = [...new Set(results.map(r => r.name))].sort()
        setOptions(unique)
      })
      .finally(() => setLoading(false))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onEfficientSearch = useCallback(
    debounce(nextValue => onSearch(nextValue), 1000),
    []
  )

  const onChangeInput = (_, nextInputValue) => {
    setValue(nextInputValue)
    setInputValue(nextInputValue)
    onEfficientSearch(nextInputValue)
  }

  return (
    <Stack
      className='Field'
      gap={2}
      sx={sx}
      direction={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
    >
      <label>{label}</label>
      <Autocomplete
        size='small'
        noOptionsText={t('no options')}
        fullWidth
        disabled={disabled}
        onChange={(_, newValue) => setValue(newValue)}
        value={value}
        onInputChange={onChangeInput}
        inputValue={inputValue}
        options={options}
        loading={loading}
        renderOption={(optionProps, option) => {
          const { key, ...restOptionProps } = optionProps
          return <li key={key} {...restOptionProps}>{option}</li>
        }}
        renderInput={params => {
          const { key, ...restParams } = params
          return (
            <TextField
              {...restParams}
              variant="filled"
              label={t('write')}
              InputProps={{
                ...restParams.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {restParams.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )
        }}
      />
    </Stack>
  )
}

export default VisitAutoComplete
